<template>
<div>

<v-dialog  v-model="tasks.modals.logs"
fullscreen hide-overlay transition="dialog-bottom-transition"
>
<app-logs :tasks = 'tasks'>
</app-logs>
</v-dialog>



<div   v-for=" item of tasks.tasksList" style="margin:5px">

<v-card  flat style="margin:15px"  >
  <v-toolbar   color="#EDEEF0" flat  >
    <v-toolbar-side-icon>

<v-tooltip v-if="item.status.status =='stop'" bottom   open-delay="1000" max-width="200"   >
<v-icon large slot="activator"     @click="activate(item,'run'); item.status='run'" >mdi-replay</v-icon>
<span>{{item.status.description.text}}</span>
</v-tooltip>


        <v-tooltip v-if="item.status.status=='run'" bottom   open-delay="1000" max-width="200"   >
     <v-icon large slot="activator" color="green"     @click="activate(item,'stop'); item.status='stop'" >mdi-stop-circle-outline</v-icon>
     <span>{{item.status.description.text}}</span>
    </v-tooltip>


     <v-tooltip v-if="item.status.status=='error'" bottom   open-delay="1000" max-width="200"   >
     <v-icon large slot="activator" color="red"     @click="activate(item,'run'); item.status='stop'" >mdi-alert-circle</v-icon>
     <span>{{item.status.description.text}}</span>
    </v-tooltip>



      </v-toolbar-side-icon>






    <v-toolbar-title    >
      <v-flex>
        <span style="cursor:pointer;color:#4A76A8;" @click="taskResources(item)">  {{item.name}}  </span>
        <div v-if="item.status.status =='stop'"  style="font-size:0.7em;color:#757575"> задание не запущено, <span @click="activate(item,'run')" style="text-decoration:underline;cursor:pointer">кликните</span> если хотите запустить</div>
        <div v-if="item.status.status =='run'"  style="font-size:0.7em;color:green"> задание активно работает, <span @click="activate(item,'stop')" style="text-decoration:underline;cursor:pointer">кликните</span> если хотите остановить </div>
        <div v-if="item.status.status =='error'"  style="font-size:0.7em;color:red">остановлено с ошибкой, подробнее <v-tooltip  bottom     max-width="200"   ><span  slot="activator" style="text-decoration:underline">об ошибке</span><span>{{item.status.description.text}}</span></v-tooltip></div>

      </v-flex>

     </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn v-if="JSON.parse(item.actions).messageSend.activated || JSON.parse(item.actions).postActions.activated" icon @click="taskMsg(item)">
    <v-tooltip top max-width="250">  <v-icon color="green" slot="activator"   >mdi-message</v-icon> <span>Данное задание отправляет сообщения, кликните что бы посмотреть.</span>  </v-tooltip>
    </v-btn>

    <v-btn v-if="JSON.parse(item.actions).friendRequest.afterAccept.is && JSON.parse(item.actions).friendRequest.activated" icon @click="taskMsg(item)">
    <v-tooltip top max-width="250">  <v-icon color="green" slot="activator"   >mdi-message</v-icon> <span>Задание отправляет сообщения новым друзьям, кликните что бы посмотреть.</span>  </v-tooltip>
    </v-btn>

    <v-btn  icon @click="changeParams(item)">
    <v-tooltip top max-width="250">  <v-icon color="#273C51" slot="activator"   >mdi-tune</v-icon> <span>Изменить параметры задания</span>  </v-tooltip>
    </v-btn>


    <v-btn icon>
    <v-tooltip top max-width="250">  <v-icon color="#C46B19" slot="activator" @click="del(item)" >mdi-close</v-icon> <span> Удалить задание</span>  </v-tooltip>
    </v-btn>


  </v-toolbar>

</v-card>
</div>




</div>
</template>

<script>

import axios from 'axios'

export default {

props:['tasks','modals','creator'],
  data () {
    return {

    }
  },
methods:{
changeParams(item){
this.creator.taskId  = item.task_id
this.creator.isEditor = true
this.creator.panel = [false,false,false,false]
this.creator.creationPath = "/tasks/edit_task.php"
const actions = JSON.parse(item.actions)
const params = JSON.parse(item.params)
this.creator.newTask.name = item.name
this.creator.newTask.accGroupId = item.act_acc_gr
this.taskAccounts(item)
this.creator.newTask.preActions = JSON.parse(item.preActions)
this.creator.newTask.accounts = JSON.parse(item.act_accounts)
this.creator.newTask.actions = actions
this.creator.newTask.resources = item.resurces
this.creator.newTask.traffControl = params.traffControl
this.creator.newTask.resourcesTimeout = params.resourcesTimeout
this.creator.newTask.actionsTimeout = params.actionsTimeout
this.creator.newTask.stopBlock = params.stopBlock
this.creator.newTask.stopLimit = params.stopLimit
this.creator.newTask.replaceThenBlock = params.replaceThenBlock
this.creator.newTask.replaceThenLimit = params.replaceThenLimit
this.creator.newTask.sequentialBlock  = params.sequentialBlock
this.creator.newTask.exceptDuble = params.exceptDuble
this.creator.newTask.allActionsImportant = params.allActionsImportant
this.creator.newTask.accountSettings.mode = params.accountsMode
this.creator.procesess.procUpdates.selected = JSON.parse(item.dynamic_resources).procesess
this.creator.filters.selected = params.filters

this.modals.creator = true
},


taskMsg(item){
this.tasks.modals.msg = true
this.tasks.task.info = item
this.tasks.task.name = item.name
},


 activate(item, status){
   //console.log(item)
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/activator.php', {
        method: 'POST',
        data: {
          id: item.task_id,
          status:status
        }
      })
      .then( response => {
          item.status = JSON.parse(response.data.status)
        if(response.data.status){
            axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/page_actions.php', {
              method: 'POST', data:{id:response.data.task_id }
            })
            .then( response=>{
this.tasksData()
            })
        }
      })
 },
 tasksData(){
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
        method: 'POST',
        data: {
          contentType: 'pages'
        }
      })
      .then( response => {
        this.tasks.loading = false
           response.data.forEach(
          (item,i,arr)=>{
            item.status = JSON.parse(item.status)
          }
        )
        this.tasks.tasksList = response.data
      })

 },





  taskResources(item){
        this.tasks.modals.resources = true

        this.tasks.task.info = item


        this.tasks.task.name = item.name


        this.tasks.task.resources.foundData.selector = false
        this.tasks.task.resources.foundData.foundIds = []
        this.tasks.task.resources.foundData.displayIds = []
        this.tasks.task.resources.foundData.selectedIds = []
        this.tasks.task.resources.foundData.offset = 0
        this.tasks.task.resources.foundData.selectAll = false

        this.tasks.task.resources.foundDataDone.selector = false
        this.tasks.task.resources.foundDataDone.foundIds = []
        this.tasks.task.resources.foundDataDone.displayIds = []
        this.tasks.task.resources.foundDataDone.selectedIds = []
        this.tasks.task.resources.foundDataDone.offset = 0
        this.tasks.task.resources.foundDataDone.selectAll = false





  },


  taskAccounts(item){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
         method: 'GET',
         params: {grId:item.act_acc_gr},
       })
       .then( response => {
         this.creator.newTask.accountsAll = response.data
       })
  },



  del(item){
    this.tasks.deleteTask.modal = true
    this.tasks.deleteTask.taskId = item

  },

  taskData(id){

    this.tasks.task.selectedTaskId = id
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_by_id.php', {
         //contentType: 'JSONP',
         method: 'POST',
         data: {
           id: this.tasks.task.selectedTaskId
         }
       })
       .then( response => {
         this.tasks.task.accounts = JSON.parse(response.data.act_accounts)
         this.tasks.task.resources =  response.data.resurces.split(',')
         this.tasks.task.actions = JSON.parse(response.data.actions)
         this.tasks.task.name =  response.data.name
         this.tasks.task.params =  JSON.parse(response.data.params)
       })
  },




},
beforeDestroy() {
clearTimeout(this.tasks.task.timeoutUpdate);
}

}
</script>

<style   >

</style>
